export const rtlProps = { dir: 'rtl', lang: 'fa' };

export const TEXT = {
    labels: { id: 'ID' },
    addSection: 'افزودن سرفصل',
    sectionSettings: 'مشخصات سرفصل',
    contentsHeader: 'محتوای سرفصل',
    addContent: 'اضافه کردن محتوا',
    noContents: 'هنوز هیچ محتوایی برای این سرفصل تعریف نشده است.',
    buttons: {
        cancel: 'لغو',
        save: 'ذخیره',
        saveNew: 'افزودن سرفصل',
    },
    switch: {
        active: 'فعال',
        inactive: 'غیرفعال'
    }
};

export const defaultNewSection = (courseId) => ({
    id: '',
    position: 0,
    description: '',
    version: 1,
    is_active: true,
    course_id: courseId,
    contents: []
});

export const CONTENT_TYPE = {
    LESSON: 0,
    PROJECT: 1,
};

export const BLOCK_TYPES = [
    { type: "text", label: "متن" },
    { type: "heading", label: "سرتیتر" },
    { type: "image", label: "تصویر" },
    { type: "question_single_choice", label: "تک‌گزینه‌ای" },
    { type: "question_multiple_choice", label: "چندگزینه‌ای" },
    { type: "list", label: "لیست" },
    { type: "info", label: "دانستنی" },
    { type: "warning", label: "هشدار" },
    { type: "code", label: "کد" },
    { type: "code_web", label: "کد وب" },
    { type: "code_fill", label: "کد ادیت" },
    { type: "placeholder_code", label: "کد جای‌خالی" },
];

export const LANGUAGES = [
    "python",
    "html",
    "css",
    "javascript",
    "typescript",
    "java",
    "cpp",
    "c",
    "go",
    "rust",
    "php",
];

export const RUNNERS_BY_TYPE = {
    program: ["python", "node", "java", "cpp"],
    sql: ["sqlite"],
    web: ["web-preview"]
};

